<template>
  <div>
    <div class="d-flex align-center mb-6">
      <p class="text-2xl mb-0">Debug - PPTX Test</p>
    </div>

    <v-card>
      <v-card-title>Test PptxGenJS</v-card-title>
      <v-card-text>
        <p class="mb-4">Test PPTX generation for different templates</p>
        <div class="d-flex flex-wrap">
          <v-btn
            class="mr-4 mb-4"
            color="primary"
            :loading="generatingTemplate === 1"
            @click="handleGenerateTemplate(1)"
          >
            <v-icon left>{{ icons.mdiDownload }}</v-icon>
            Download PPTX - template 1
          </v-btn>
          <v-btn
            class="mr-4 mb-4"
            color="primary"
            :loading="generatingTemplate === 2"
            @click="handleGenerateTemplate(2)"
          >
            <v-icon left>{{ icons.mdiDownload }}</v-icon>
            Download PPTX - template 2
          </v-btn>
          <v-btn
            class="mr-4 mb-4"
            color="primary"
            :loading="generatingTemplate === 3"
            @click="handleGenerateTemplate(3)"
          >
            <v-icon left>{{ icons.mdiDownload }}</v-icon>
            Download PPTX - template 3
          </v-btn>
          <v-btn
            class="mb-4"
            color="primary"
            :loading="generatingTemplate === 4"
            @click="handleGenerateTemplate(4)"
          >
            <v-icon left>{{ icons.mdiDownload }}</v-icon>
            Download PPTX - template 4
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mdiDownload } from "@mdi/js";
import { generateTemplate1 } from "./pptx-templates/template1";
import { generateTemplate2 } from "./pptx-templates/template2";
import { generateTemplate3 } from "./pptx-templates/template3";
import { generateTemplate4 } from "./pptx-templates/template4";

export default {
  name: "Debug",
  data() {
    return {
      generatingTemplate: null,
      icons: {
        mdiDownload,
      },
    };
  },
  methods: {
    async handleGenerateTemplate(templateNumber) {
      this.generatingTemplate = templateNumber;

      try {
        switch (templateNumber) {
          case 1:
            await generateTemplate1();
            break;
          case 2:
            await generateTemplate2();
            break;
          case 3:
            await generateTemplate3();
            break;
          case 4:
            await generateTemplate4();
            break;
        }
      } catch (error) {
        console.error("Error generating PPTX:", error);
        this.$store.dispatch("app/setSnackBar", {
          show: true,
          text: "Erreur lors de la génération du PPTX: " + error.message,
          color: "error",
          timeout: 5000,
        });
      } finally {
        this.generatingTemplate = null;
      }
    },
  },
};
</script>
